/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:51:22
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-21, 10:22:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
/* eslint-disable */
import { xor, difference } from 'lodash';

/**
 * Usuwa (jeżeli jest) lub dodaje (jeżeli nie ma) element do tablicy.
 * Wykorzystuje funkcje _.xor() z biblioteki lodash
 * @param {Array} array
 * @param {any} item
 * @returns {Array} newArray
 */
export const hToggleArrayItem = (array, item) => xor(array, [item]);

export const hCreateNewStyleElementInDOM = (cssContent) => {
  const newStyleElement = document.createElement('style');
  newStyleElement.innerHTML = cssContent;
  document.body.appendChild(newStyleElement);
};

export const hCompareTwoArraysAndReturnDifference = (arrFirst, arrSecond) => difference(arrFirst ,arrSecond)

export const hMapCollectionByCondition = (collection, key, condition = {}) => {
  if (!(key in collection[0])) return [];
  
  return collection
    .filter(item => Object.keys(condition).every(_key => item[_key] === condition[_key]), condition)
    .map(item => item[key]);
}

/**
 * name: hDeepCopy
 *
 * creates deep copy of object (HACK)
 *
 * @param {Object} object
 * @return {Object}
 */
export const hDeepCopy = object => JSON.parse(JSON.stringify(object));




// WEBPACK FOOTER //
// ./src/utils/helpers.js